<template>
    <div  :style="{'height':clientHeight-90+'px'}">
        <vue-scroll :ops="$ops">
            <div >
                <div class="m-portlet m-b-10">
                    <div class="m-portlet__body">
                        <el-form label-width="100px" style="width: 1000px">
                            <el-row :gutter="20">
                                <el-col :span="8">
                                    <el-form-item label="选择学期">
                                        <el-select v-model="semesterType_id"  placeholder="请选择学期" filterable remote
                                                   @change="changeSemesterType()">
                                            <el-option
                                                    v-for="item in semesterTypes"
                                                    :key="item.id"
                                                    :label="item.name"
                                                    :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label="选择对比学期">
                                        <el-select v-model="contrastSemesterType_ids"
                                                   clearable
                                                   placeholder="请选择对比学期"
                                                   multiple
                                                   remote
                                                   @change="changeSemesterType()">
                                            <el-option
                                                    v-for="item in nextSemesterTypes"
                                                    :key="item.id"
                                                    :label="item.name"
                                                    :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label="">
                                        <el-switch v-model="showStudent"
                                                   active-text="小数"
                                                   size="small">
                                        </el-switch>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </div>
                </div>
                <div class="m-portlet m-b-0">
                    <div class="m-portlet__body" v-loading="loading">
                        <el-table
                                :data="headTeacherRenewals"
                                style="width: 100%"
                                size="middle">
                            <el-table-column prop="headTeacher_name" label="班主任" align="center"></el-table-column>

                            <el-table-column prop="rate" label="续班率" align="center" v-if="!showStudent"></el-table-column>
                            <el-table-column prop="rate_decimal" label="续班率" align="center" v-else></el-table-column>
                            <el-table-column v-for="(item, index) in headTeacherRenewals[0].semesterData" min-width="3%" :key="index" align="center">
                                <template slot="header" slot-scope="scope" style="text-align: center">
                                    {{item.semester_name}}
                                </template>
                                <el-table-column label="报班学生数" align="center">
                                    <template slot-scope="scope">{{scope.row.semesterData[index].student_number}}</template>
                                </el-table-column>
                                <el-table-column label="平均报班数" align="center">
                                    <template slot-scope="scope">{{scope.row.semesterData[index].avg_student_class}}</template>
                                </el-table-column>
                                <el-table-column label="报班数大于等于3门" align="center">
                                    <template slot-scope="scope">{{scope.row.semesterData[index].more_then_three_class}}</template>
                                </el-table-column>
                                <el-table-column label="报班数小于3门" align="center">
                                    <template slot-scope="scope">{{scope.row.semesterData[index].less_class}}</template>
                                </el-table-column>
                            </el-table-column>
                        </el-table>
                        <!--分页-->
                        <div class="text-center m-t-10">
                            <el-pagination
                                    @size-change="handleSizeChange"
                                    @current-change="handleCurrentChange"
                                    :current-page="currentPage"
                                    :page-sizes="[10, 20, 50, 100]"
                                    :page-size="10"
                                    layout="total, sizes, prev, pager, next, jumper"
                                    :total="total">
                            </el-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </vue-scroll>
    </div>
</template>

<script>

    export default {
        data() {
            return {
                path:"/renewalHeadTeacher/list",
                semesterTypes:[],
                semesterType_id:'',
                contrastSemesterType_ids:[],
                loading: true,
                showStudent:false,
                nextSemesterTypes:[],
                date: '',
                start_date: '',
                end_date: '',
                headTeacherRenewals:[
                    {
                        name:'',
                        rate:'',
                        semesterData:''
                    }
                ],
                total: 0,
                currentPage: 1,
                currentPageSize: 10,
            };
        },
        mounted() {
            this.$nextTick(() => {
            })
        },
        created() {
            this.semester_id=this.$store.state.config.nowSemester.id;
            this.handleIndex();
            this.handleShow();
            this.handleCreate();

        },
        computed: {
            right_level() {
                return this.$store.state.user.employee.right_level;
            },
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
        },
        methods: {
            handleCreate(){
                //建立webSocket链接
                this.$wApi.addListen(this.path,this.handleData);
            },
            handleShow() {
                this.$wApi.send(this.path,'init',{});
            },
            handleData(event,data){
                switch (event) {
                    case 'init':
                        this.semesterTypes =data.semesterTypes;
                        this.semester=3;
                        break;
                    case 'new_list':
                        this.total = data.total;
                        this.headTeacherRenewals = data.headTeacherRenewals;
                        this.nextSemesterTypes=data.nextSemesterTypes
                        this.semesterType_id=data.semesterType_id
                        this.loading = false;
                        break;
                }
            },
            changeSemesterType(){
                this.loading = true;
                this.handleIndex();
            },
            handleIndex(currentPage = 1) {
                if (currentPage === 1) {
                    this.currentPage = 1
                }
                this.$wApi.send(this.path, 'new_list', {
                    'currentPage': this.currentPage,
                    'currentPageSize': this.currentPageSize,
                    'semesterType_id': this.semesterType_id,
                    'contrastSemesterType_ids': this.contrastSemesterType_ids,
                    'nowSemester_id': this.$store.state.config.nowSemester.id,
                });
            },
            handleSizeChange(val) {
                this.currentPageSize = val;
                this.loading = true;
                this.handleIndex(this.currentPage, this.currentPageSize)
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.loading = true;
                this.handleIndex(this.currentPage, this.currentPageSize)
            },
        }
    }
</script>


<style scoped>

</style>
